<div class="overlay">
    <div class="center">
        <div class="spinner-text">{{text}}</div>
        <div class="spinner">
            <mat-progress-spinner [diameter]="diameter" [mode]="mode" [color]="color" [strokeWidth]="strokeWidth"></mat-progress-spinner>    
        </div>
    </div>
</div>